import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowUpRight } from 'lucide-react';

const IMAGES = {
  mining: 'https://images.unsplash.com/photo-1651260414968-7f27e8db866f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxtaW5pbmclMjBlcXVpcG1lbnR8ZW58MHx8fHwxNzc1NTAyNzU1fDA&ixlib=rb-4.1.0&q=85',
  horeca: 'https://images.unsplash.com/photo-1774716925718-82ea2f2eb01b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwa2l0Y2hlbiUyMHN0YWlubGVzc3xlbnwwfHx8fDE3NzU1MDI3Mzd8MA&ixlib=rb-4.1.0&q=85',
  healthcare: 'https://images.unsplash.com/photo-1690306815542-3c0e7b85e996?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwbWVkaWNhbCUyMGVxdWlwbWVudCUyMHN0YWlubGVzc3xlbnwwfHx8fDE3NzU1MDI3NTV8MA&ixlib=rb-4.1.0&q=85',
  construction: 'https://images.unsplash.com/photo-1644411813513-ad77c1b77581?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc3NTUwMjczN3ww&ixlib=rb-4.1.0&q=85',
};

function ServiceCard({ sectorKey, image, span }) {
  const { t } = useLanguage();

  return (
    <div
      data-testid={`service-card-${sectorKey}`}
      className={`group relative overflow-hidden border border-[#C8C9C7] cursor-pointer ${span}`}
    >
      <img
        src={image}
        alt={t(`services.${sectorKey}.title`)}
        className="w-full h-full object-cover absolute inset-0 grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-[#333F48]/60 group-hover:bg-[#003865]/70 transition-colors duration-300" />
      <div className="relative z-10 p-8 h-full flex flex-col justify-end min-h-[280px]">
        <div className="flex items-start justify-between">
          <div>
            <h3
              className="text-xl sm:text-2xl font-bold text-white mb-3"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {t(`services.${sectorKey}.title`)}
            </h3>
            <p
              className="text-sm text-white/70 max-w-sm leading-relaxed"
              style={{ fontFamily: 'Roboto, sans-serif' }}
            >
              {t(`services.${sectorKey}.desc`)}
            </p>
          </div>
          <ArrowUpRight
            size={24}
            className="text-white/40 group-hover:text-white transition-colors duration-300 flex-shrink-0 mt-1"
          />
        </div>
      </div>
    </div>
  );
}

export default function ServicesSection() {
  const { t } = useLanguage();

  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-[#F8F8F7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-px bg-[#003865]" />
            <span
              className="text-xs font-bold uppercase tracking-[0.2em] text-[#003865]"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {t('services.overline')}
            </span>
          </div>
          <h2
            data-testid="services-title"
            className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#333F48]"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            {t('services.title')}
          </h2>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <ServiceCard sectorKey="mining" image={IMAGES.mining} span="lg:col-span-2 lg:row-span-2" />
          <ServiceCard sectorKey="horeca" image={IMAGES.horeca} span="" />
          <ServiceCard sectorKey="healthcare" image={IMAGES.healthcare} span="" />
          <ServiceCard sectorKey="construction" image={IMAGES.construction} span="lg:col-span-3" />
        </div>
      </div>
    </section>
  );
}
